export const DATA_TEST_ID_PREFIX_BUTTON = 'modal-text-button-'
